var _path, _path2, _path3, _path4, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestoomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1698 27.7989C22.6759 27.7989 23.1707 27.6488 23.5915 27.3676C24.0123 27.0864 24.3403 26.6868 24.5339 26.2192C24.7276 25.7516 24.7783 25.2371 24.6796 24.7408C24.5808 24.2444 24.3371 23.7884 23.9792 23.4306C23.6214 23.0727 23.1654 22.829 22.6691 22.7303C22.1727 22.6315 21.6582 22.6822 21.1906 22.8759C20.723 23.0696 20.3234 23.3975 20.0422 23.8183C19.761 24.2391 19.611 24.7339 19.611 25.24C19.6117 25.9184 19.8816 26.5688 20.3613 27.0485C20.841 27.5283 21.4914 27.7981 22.1698 27.7989V27.7989ZM22.1698 24.0037C22.4144 24.0037 22.6534 24.0762 22.8567 24.212C23.06 24.3479 23.2185 24.541 23.312 24.7669C23.4056 24.9928 23.4301 25.2413 23.3824 25.4812C23.3347 25.721 23.2169 25.9413 23.044 26.1142C22.8711 26.2871 22.6508 26.4048 22.411 26.4525C22.1712 26.5002 21.9226 26.4757 21.6967 26.3822C21.4708 26.2886 21.2778 26.1301 21.1419 25.9268C21.0061 25.7235 20.9336 25.4845 20.9336 25.24C20.9339 24.9122 21.0643 24.598 21.2961 24.3662C21.5278 24.1344 21.8421 24.0041 22.1698 24.0037V24.0037Z",
    fill: "url(#paint0_radial_189:175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9883 28.3022H20.3512C19.8252 28.3028 19.3209 28.512 18.949 28.8839C18.5771 29.2558 18.3679 29.7601 18.3673 30.2861V36.5684H19.6899V42.52H24.6496V36.5684H25.9722V30.2861C25.9716 29.7601 25.7624 29.2558 25.3905 28.8839C25.0186 28.512 24.5143 28.3028 23.9883 28.3022ZM24.6496 35.2458H23.327V41.1974H21.0125V35.2458H19.6899V30.2861C19.6901 30.1107 19.7598 29.9427 19.8838 29.8187C20.0078 29.6947 20.1759 29.625 20.3512 29.6248H23.9883C24.1636 29.625 24.3317 29.6947 24.4557 29.8187C24.5797 29.9427 24.6494 30.1107 24.6496 30.2861V35.2458Z",
    fill: "url(#paint1_radial_189:175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0102 27.7989C32.5163 27.7989 33.011 27.6488 33.4318 27.3676C33.8526 27.0864 34.1806 26.6868 34.3743 26.2192C34.5679 25.7516 34.6186 25.2371 34.5199 24.7408C34.4211 24.2444 34.1774 23.7884 33.8196 23.4306C33.4617 23.0727 33.0058 22.829 32.5094 22.7303C32.013 22.6315 31.4985 22.6822 31.0309 22.8759C30.5634 23.0696 30.1637 23.3975 29.8825 23.8183C29.6014 24.2391 29.4513 24.7339 29.4513 25.24C29.452 25.9184 29.7219 26.5688 30.2016 27.0485C30.6813 27.5283 31.3317 27.7981 32.0102 27.7989V27.7989ZM32.0102 24.0037C32.2547 24.0037 32.4937 24.0762 32.697 24.212C32.9003 24.3479 33.0588 24.541 33.1524 24.7669C33.2459 24.9928 33.2704 25.2413 33.2227 25.4812C33.175 25.721 33.0573 25.9413 32.8844 26.1142C32.7115 26.2871 32.4912 26.4048 32.2514 26.4525C32.0115 26.5002 31.763 26.4757 31.5371 26.3822C31.3112 26.2886 31.1181 26.1301 30.9822 25.9268C30.8464 25.7235 30.7739 25.4845 30.7739 25.24C30.7743 24.9122 30.9046 24.598 31.1364 24.3662C31.3682 24.1344 31.6824 24.0041 32.0102 24.0037V24.0037Z",
    fill: "url(#paint2_radial_189:175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3112 30.0114C34.1392 29.5171 33.8191 29.0878 33.3944 28.7819C32.9696 28.4761 32.461 28.3087 31.9376 28.3024C31.4143 28.2961 30.9017 28.4513 30.4698 28.7468C30.0378 29.0423 29.7075 29.4638 29.5237 29.9539L26.9642 36.7792V38.5523H29.6094V42.52H33.9078V38.5523H36.553V36.4568L34.3112 30.0114ZM35.2304 37.2297H32.5852V41.1975H30.932V37.2297H28.2868V37.0189L30.7621 30.4183C30.8504 30.1829 31.0091 29.9804 31.2166 29.8385C31.4241 29.6965 31.6703 29.6219 31.9217 29.625C32.1731 29.628 32.4175 29.7084 32.6215 29.8554C32.8256 30.0023 32.9794 30.2085 33.062 30.446L35.2304 36.68V37.2297Z",
    fill: "url(#paint3_radial_189:175)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.2215,
    y: 0.990662,
    width: 52.4547,
    height: 62.7759,
    rx: 4.75,
    stroke: "url(#paint4_radial_189:175)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_189:175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8904 27.5731) rotate(-63.9967) scale(6.86653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_189:175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2685 41.8928) rotate(-75.3765) scale(17.719 10.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_189:175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7307 27.5731) rotate(-63.9967) scale(6.86653)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_189:175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3614 41.8928) rotate(-71.7896) scale(18.049 13.5974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_189:175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2102 61.2249) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoomIcon);
export default __webpack_public_path__ + "static/media/restoom_icon.8f8aaac5.svg";
export { ForwardRef as ReactComponent };